import { Heading, Image, Text, useToast } from "@chakra-ui/react";
import { Box, Center, Flex } from "@chakra-ui/layout";
import loginImage from "../assets/login.png";
import PrimaryButton from "../components/PrimaryButton";
import { NavLink, useLocation } from "react-router-dom";
import Logo from "../components/Logo";
import { resetPassword } from "../mutations/auth.mutations";
import StlLoader from "../components/StlLoader";

function ResetPasswordDonePage() {
  const location = useLocation();
  const email = location.state.email;
  const toast = useToast();

  const handleClick = async () => {
    try {
      await resetPassword({
        email,
      });
    } catch (err) {
      toast({
        title: "Mot de passe oublié",
        description: "Erreur interne",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex>
      <Box display={{ base: "none", lg: "block" }}>
        <StlLoader
          alternative={
            <Image
              src={loginImage}
              alt="Dan Abramov"
              h="100vh"
              w="50vw"
              display={{ base: "none", lg: "block" }}
            />
          }
        ></StlLoader>
      </Box>
      <Center w="100%">
        <Flex
          direction="column"
          alignItems="left"
          justifyContent={"center"}
          h="100vh"
          w="100%"
          px={{ base: "44px", md: "144px" }}
        >
          <Flex direction="column" alignItems="center">
            <Logo />
            <Heading
              fontWeight={600}
              fontSize="32px"
              lineHeight="48px"
              color="gray.900"
            >
              Vérifiez vos emails
            </Heading>
            <Text
              fontWeight={400}
              fontSize="20px"
              lineHeight="30px"
              color="gray.600"
              textAlign="center"
            >
              Nous avons envoyé un lien de réinitialisation à
            </Text>
            <Text fontWeight={600} fontSize="20px" color="gray.600">
              {email}
            </Text>
            <Text mt="24px" fontWeight={400} fontSize="14px">
              Vous n'avez rien reçu ?
            </Text>
          </Flex>

          <PrimaryButton mt="10px" onClick={handleClick}>
            Renvoyer l'email
          </PrimaryButton>
          <Center
            my="24px"
            color="brand.700"
            _hover={{ textDecoration: "underline" }}
          >
            <NavLink to="/login">Retour à la connexion</NavLink>
          </Center>
        </Flex>
      </Center>
    </Flex>
  );
}

export default ResetPasswordDonePage;
